<template>
	<div class="filter uitvoering">
		<h1 class="thermo">Type</h1>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/all')">Alle opdrachten</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/all'"
				@change="emitFilterChange('uitvoering/all')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/bodemisolatie')">Bodemisolatie</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/bodemisolatie'"
				@change="emitFilterChange('uitvoering/bodemisolatie')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/FTX1')">FTX1</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/FTX1'"
				@change="emitFilterChange('uitvoering/FTX1')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/gilde')">Gilde</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/gilde'"
				@change="emitFilterChange('uitvoering/gilde')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/impregneren')">Impregneren</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/impregneren'"
				@change="emitFilterChange('uitvoering/impregneren')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/leeghalen')">Leeghalen</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/leeghalen'"
				@change="emitFilterChange('uitvoering/leeghalen')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/thermofoam')">ThermoFoam</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/thermofoam'"
				@change="emitFilterChange('uitvoering/thermofoam')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/vloerisolatie')">Vloerisolatie</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/vloerisolatie'"
				@change="emitFilterChange('uitvoering/vloerisolatie')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('uitvoering/ventilatierooster')">Ventilatierooster</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'uitvoering/ventilatierooster'"
				@change="emitFilterChange('uitvoering/ventilatierooster')"
			/>
		</div>

	</div>
</template>

<script>
import ToggleField from "@/components/ToggleField.vue";
import moment from "moment";

export default {
	components: {
		ToggleField,
	},

	props: {
		filter: String
	},
	watch: {
		filter() {
			if(this.filter === this.currentFilter){
				return;
			}
			this.currentFilter = this.filter;
			this.emitFilterChange(this.filter);
		}
	},

	data() {
		return {
			currentFilter: 'uitvoering/all',
			afterDate: moment().subtract(1, "months").format("YYYY-MM-DD")
		};
	},

	mounted() {
		this.emitFilterChange(this.currentFilter);
	},
	methods: {
		emitFilterChange(filter) {
			this.currentFilter = filter;
			this.$emit('filterChange', {
				filter: this.currentFilter,
				filterType: "project",
				afterDate: this.afterDate
			});
		}
	}
};
</script>

<style scoped lang="scss">
.filter-item {
	display: flex; justify-content: space-between; margin-bottom: 0.5em;
}
</style>
